import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Filter, X } from "lucide-react";

/** Only render when isPanIndia is true. Compact filter for state/city. */
export default function PanIndiaFilter({ isPanIndia, filterOpts, fState, setFState, fCity, setFCity }) {
  if (!isPanIndia || !filterOpts?.states?.length) return null;
  const cityOptions = fState ? filterOpts.cities_by_state?.[fState] || [] : [];
  return (
    <Card className="p-4 mb-6 border-primary/30" data-testid="panindia-filter">
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex items-center gap-2">
          <Filter className="h-4 w-4 text-primary" />
          <span className="text-sm font-medium">Pan India filter</span>
        </div>
        <div className="flex-1 min-w-[180px]">
          <Label className="text-xs">State</Label>
          <Select value={fState || "__all"} onValueChange={(v) => { const nv = v === "__all" ? "" : v; setFState(nv); if (!nv) setFCity(""); }}>
            <SelectTrigger data-testid="filter-state"><SelectValue placeholder="All states" /></SelectTrigger>
            <SelectContent className="bg-popover">
              <SelectItem value="__all">All states</SelectItem>
              {filterOpts.states.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="flex-1 min-w-[180px]">
          <Label className="text-xs">City</Label>
          <Select value={fCity || "__all"} onValueChange={(v) => setFCity(v === "__all" ? "" : v)} disabled={!fState || cityOptions.length === 0}>
            <SelectTrigger data-testid="filter-city"><SelectValue placeholder={fState ? "All cities" : "Select state first"} /></SelectTrigger>
            <SelectContent className="bg-popover">
              <SelectItem value="__all">All cities</SelectItem>
              {cityOptions.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        {(fState || fCity) && (
          <Button variant="ghost" size="sm" onClick={() => { setFState(""); setFCity(""); }} data-testid="filter-clear">
            <X className="h-4 w-4 mr-1" /> Clear
          </Button>
        )}
      </div>
      <div className="text-xs text-muted-foreground mt-2">
        Filters apply to previews and downloads. Leave blank to see the full dataset.
      </div>
    </Card>
  );
}
